import React from 'react'
import SubmitInformation from '../../components/User/MerchantOnboard/SubmitInformation';

const OnBoardSubmitInformation = () => {
  return (
    <SubmitInformation />
  )
}

export default OnBoardSubmitInformation;